<template lang="pug">
  div.note
    v-dialog(
      v-model="showModal"
      width="520"
      persistent
    )

      template(v-slot:activator="{ on }")

        // Open Modal button
        div.text-xs-right
          button.noteButton(
            v-on="on"
            @click="toggleModal"
            color="primary"
          )
            v-icon add
            span {{ $t('journal.list.createNote') }}

      div.dialogWrapper
        v-form.c-form(autocomplete="off")
          v-container(fluid grid-list-lg)
            v-layout.align-center(raw wrap)

              v-flex(xs6)

                // Title
                title-component(title="Add Note" type="h3")

              v-flex.text-xs-right.mb-2(xs6)

                // Close Modal window
                button-icon(:action="resetNote" color="white" icon="close")

              v-flex(xs12)

                // Assign Theme selection
                v-select(
                  name="noteType"
                  append-icon="expand_more"
                  outline
                  v-model.lazy="model.noteType"
                  :items="$t('selection.noteTypes')"
                  :data-vv-as="$t('fields.noteType')"
                  :v-validate="'required'"
                  :error-messages="errors.collect('noteType')"
                  :label="$t('fields.noteCategory')"
                )

              v-flex(xs12)

                // Title field
                v-text-field(
                  :error-messages="errors.collect('title')"
                  :data-vv-as="$t('fields.noteTitle')"
                  :label="$t('fields.noteTitle')"
                  name="title"
                  v-model="model.title"
                  v-validate="'required|min:2|max:150'"
                  outline
                )

              v-flex(xs12)

                // Body field
                v-textarea(
                  name="body"
                  rows="2"
                  outline
                  v-model.lazy="model.body"
                  v-validate="'min:2|max:2000'"
                  :data-vv-as="$t('fields.noteText')"
                  :error-messages="errors.collect('body')"
                  :label="$t('fields.noteText')"
                )

              v-flex(xs12)

                // Horizontal line
                separator-component

                div.controls
                  div

                    // Cancel button
                    button-component.ml-0(
                      :action="resetNote"
                      :isLoading="isLoading"
                      :disabled="isLoading"
                      color="grey"
                      large
                      outline
                    ) {{ $t('defaultButtons.cancel') }}

                  div

                    // Submit button
                    button-component.mr-0.submit(
                      :action="submit"
                      :isLoading="isLoading"
                      :disabled="isLoading"
                      color="white"
                      large
                    ) {{ $t('defaultButtons.save') }}
</template>

<script>
    import { mapFields } from 'vuex-map-fields';
    import { mapActions, mapGetters } from 'vuex';
    import Button from '../Button';
    import ButtonIcon from '../ButtonIcon';
    import Separator from '../Separator';
    import Title from '../Title';
    import VueTypes from 'vue-types';

    export default {
        props: {
            saveCallback: VueTypes.func.def(() => {})
        },
        components: {
            ButtonIcon,
            ButtonComponent: Button,
            SeparatorComponent: Separator,
            TitleComponent: Title
        },
        data() {
            return {
                timeStart: null,
                prompts: {
                    goals: 'My goals for today are: ',
                    gratitude: 'I am grateful for ',
                    intentions:
                        'My intention(s) for today’s practice is (are) ',
                    notes: 'Note Text ',
                    reflections: "Today I'm reflecting on ",
                    visualization: "Today I'm visualizing "
                }
            };
        },
        computed: {
            ...mapFields('notes', {
                model: 'note'
            }),
            ...mapGetters('notes', ['isLoading', 'showModal'])
        },
        watch: {
            ['model.noteType']() {
                if (this.model.id && this.model.body) return;

                this.model.body = this.prompts[this.model.noteType];
            }
        },
        created() {
            this.timeStart = new Date();
        },
        methods: {
            ...mapActions('notes', [
                'resetNote',
                'createNote',
                'triggerModal',
                'updateNote'
            ]),

            toggleModal() {
                this.triggerModal();
            },

            async submit() {
                const validation = await this.$validator.validateAll();
                if (!validation) return;

                const endTime = new Date();
                const timeDiff =
                    (endTime.getTime() - this.timeStart.getTime()) / 1000;

                const viewData = {
                    time: parseInt(timeDiff).toString(),
                    sessionId: process.env.VUE_APP_JOURNAL_SESSION_ID,
                    type: 'recorded'
                };

                this.model.id ? this.updateNote() : this.createNote();

                return this.saveCallback(viewData);
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl"

    .note
      display: flex
      align-items: center

    .dialogWrapper
      background: $theme.primary

    .noteButton
      display: flex
      align-items: center

      i
        width: 24px
        height: 24px
        border-radius: 24px
        background-color: $theme.action
        display: flex
        align-items: center
        justify-content: center
        margin-right: 7px
        color: $theme.white
</style>
